import { render, staticRenderFns } from "./AddManager.vue?vue&type=template&id=78ce1dfe&scoped=true&"
import script from "./AddManager.vue?vue&type=script&lang=js&"
export * from "./AddManager.vue?vue&type=script&lang=js&"
import style0 from "./AddManager.vue?vue&type=style&index=0&id=78ce1dfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ce1dfe",
  null
  
)

export default component.exports